import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js'
import { elementsToMaxWidth } from './utils/elemntsToMaxSizes'
import { breakpointUp, breakpoint } from './utils/breakpoints'
import { menuOpenAnimation } from './animations/menu'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

let menuScroll = null

/**
 * Initialise navigation
 * @param locoScroll
 * @param scroller
 */
function setupMenuNavigation (locoScroll, scroller) {

  // Handle menu button click
  $('body').on('click', '.js-main-menu', function (e) {
    e.preventDefault()
    toggleMenu()
  })
  elementsToMaxWidth($('.c-btn-menu .is-text'))

  // Change menu toolbar colors
  if (breakpointUp('lg')) {
    if (menuScroll) { menuScroll.kill() }

    let navigationPosition = locoScroll.scroll.instance.scroll.y
    const scrollUp = document.querySelector('.navigation')

    menuScroll = ScrollTrigger.create({
      start: `top-=${navigationPosition} top-=10%`,
      end: 99999,
      scroller: scroller,
      //markers: true,
      toggleClass: { className: 'is-scrolled', targets: '.navigation' },
      onUpdate: ({ direction }) => {
        if (direction === -1) {
          scrollUp.classList.remove('is-up')
        } else {
          scrollUp.classList.add('is-up')
        }
      },
    })
  }

  document.querySelectorAll("[data-menu-nav]").forEach(box =>
    box.addEventListener("click", function (e) {
      e.preventDefault()

      let menuID = $(this).attr('data-menu-nav')

      if ($(`[data-menu-id="${menuID}"]`).length) {
        if ($('[data-menu-id="' + menuID + '"]').length) {
          //menu_timeline.play(menuID)
          scrollTo(menuID, locoScroll)

          if ($(this).parent().hasClass('menu-item')) {
            toggleMenu()
          }
        }
      } else {
        window.location = $(this).attr('href')
      }
    })
  )


  // Prepare triggers when scrolling
  if (locoScroll != null) {
    const boxes = gsap.utils.toArray('[data-menu-id]')
    boxes.forEach(box => {
      ScrollTrigger.create({
        trigger: box,
        start: 'top center+=10',
        end: 'bottom center-=10',
        scroller: scroller,
        onEnter: playNav,
        onEnterBack: playNav,
        //markers: true
      })
    })
  }
}

// Animate scrolling position
function scrollTo (menuID, locoScroll) {
  setTimeout(function () {
    if (locoScroll) {
      const target = document.querySelector(menuID)
      locoScroll.scrollTo(target)
    } else {
      const target = document.getElementById(menuID.replace('#', ''))
      var pos = getPosition(target)
      $('html, body').animate({
        scrollTop: pos.y,
      }, 500)
    }
  }, 200)

}

function toggleMenu () {
  let menuContainer = $('.navigation')
  menuContainer.toggleClass('is-opened')
  $('html').toggleClass('menu-opened')
  if (menuContainer.hasClass('is-opened')) {
    menuOpenAnimation()
  }
}

// Handles hash change
function playNav (instance) {
  let navName = $(instance.trigger).attr('data-menu-id')
  if (navName === '') {
    navName = $('.logo').attr('href')
  }

  if (!navName || !(window.history && window.history.pushState)) {
    return
  }

  try {
    // Prevent cross-origin URLs from crashing pushState.
    const parsedUrl = new URL(navName, window.location.href)
    if (parsedUrl.origin !== window.location.origin) {
      return
    }

    history.pushState({}, null, parsedUrl.pathname + parsedUrl.search + parsedUrl.hash)
  } catch (error) {
    // Ignore invalid URLs/hashes and keep navigation functional.
  }
}

/**
 * On page load, resolve hashtag in url
 * @param locoScroll
 */
function setupMenuAction (locoScroll) {
  if (!window.location.hash) {
    return
  }

  // If locomotive scroll is initialised
  if (locoScroll != null) {
    const target = document.querySelector(window.location.hash)
    if (target) {
      locoScroll.scrollTo(target)
    }
  } else {
    const target = document.getElementById(
      window.location.hash.replace('#', ''))
    if (target) {
      var pos = getPosition(target)
      $('html, body').animate({
        scrollTop: pos.y,
      }, 500)
    }
  }
}

function getPosition (element) {
  var top = 0, left = 0
  do {
    top += element.offsetTop || 0
    left += element.offsetLeft || 0
    element = element.offsetParent
  } while (element)

  return {
    y: top,
    x: left,
  }
}

export { setupMenuNavigation, setupMenuAction }
